import { useMutation, useQuery, useQueryClient } from "react-query";
import qs from "qs-lite";

import api from "../../utils/api";
import { useHubSnackBar } from "../useSnackBar";
import { invalidate } from "../../helpers/clientHelper";
import { clearCachedItem } from "../../helpers";

const USER = "/user";

const getUserList = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  const query = queryString ? `?${queryString}` : "";
  return api.get(`${USER}/list${query}`);
};
export const useGetUserList = ({ locationId = null, enabled = true }) => {
  return useQuery([USER, { locationId }, "list"], getUserList, { enabled });
};

const getAllUserData = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${USER}/table?${queryString}`);
};
export const useGetAllUserData = ({ defaultLocation = 1 }) => {
  const query = new URLSearchParams(window.location.search);

  const location = query.get("location") || defaultLocation;
  const status = query.get("status") || "A";
  const role = query.get("role") || "All";

  const orderBy = query.get("orderBy") || "name";
  const sortOrder = query.get("sortOrder") || "asc";
  const limit = query.get("limit") || 100;
  const offset = query.get("offset") || 0;

  const queryProps = {
    limit,
    offset,
    orderBy,
    sortOrder,
    ...(!location || location === "All" ? {} : { location }),
    ...(!status || status === "All" ? {} : { status }),
    ...(!role || role === "All" ? {} : { role }),
  };

  return useQuery([USER, queryProps, "table"], getAllUserData);
};

const getUserById = (id) => api.get(`${USER}/${id}`);
export const useGetUserById = ({ id }) =>
  useQuery([USER, id], () => getUserById(id));

const putUserData = (data) => {
  const id = data.id;
  delete data.id;
  return api.put(`${USER}/${id}`, data);
};
export const usePutUserData = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(putUserData, {
    onSuccess: () => {
      invalidate(queryClient, USER);
      clearCachedItem("users");
      addSnackbarSuccess({ message: "Successfully Updated User" });
    },
  });
};
